import React, { useContext, useEffect, useState } from 'react'
import LenderUgroService from '../../../../services/lender';
import { useParams } from 'react-router';
import { Context } from '../../../../config/store';
import PayToCustomerModal from './PayToCustomerModal';
import ReactTooltip from 'react-tooltip';

const PayToCustomer = ({ paytype, isBtCase }) => {

    const leadId = useParams().id;
    const { state } = useContext(Context);

    const [disbursalData, setDisbursalData] = useState(null)
    const [transactionData, setTransactionData] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [loader, setLoader] = useState(false);
    const [drfData, setDrfData] = useState([])
    const [drfDataArray, setDrfDataArray] = useState([])
    const [retryData, setRetryData] = useState({})

    useEffect(() => {
        setLoader(true)
        fetchPayToCustomerDetails()
    }, [paytype])


    const fetchPayToCustomerDetails = () => {
        LenderUgroService.getPayToCustomerDetails({
            type: state.userType,
            leadId: leadId,
            paytype: paytype == "Bank" ? "paytobank" : "paytocustomer"
        }).then((response) => {
            let responseData = response?.data?.data;
            setDisbursalData(responseData?.disbursal_detail)
            let drf_data = responseData?.drf_detail;
            setDrfDataArray(drf_data || [])
            let newData = {};
            drf_data?.map((item) => {
                if (item?.bank_acc_id) {
                    return newData[item?.bank_acc_id] = item
                }
            })
            setDrfData(newData)
            setTransactionData(responseData?.transaction_detail || [])
            setLoader(false)
        }).catch((err) => {
            setLoader(false)
        });
    }
    const togglePayToCustomerModal = () => {
        showModal && setRetryData([])
        setShowModal(!showModal)
    }

    const checkHasPermission = (checkPermission) => {
        if (state.is_super_admin === 1) return true;
        const permission = state.permission.find(
            (permission) => permission === checkPermission
        );

        if (permission) return true;
        else return false;
    };

    const handleRetryPayment = (data) => {
        setRetryData(data)
        setShowModal(!showModal)
    }

    const checkIsFailed = (trans) => {
        return trans?.api_status > 0;
    }

    return (
        <>
            {loader ?
                <div className='Tableloader' style={{ margin: "100px auto" }}></div>
                :
                <>
                    {disbursalData !== null ?
                        <div style={{ borderRadius: "5px", width: "100%", border: "1px solid #CBCBCB" }}>
                            <div className='border p-2' style={{ backgroundColor: "#F8F8F8", borderRadius: "5px 5px 0 0 " }}>
                                <h5>Customer Disbursement Details</h5>
                            </div>
                            {disbursalData !== null ?
                                <div className='row p-2'>
                                    <div className='col-md-4'>
                                        <p className='detailsRightLabel'>{'Customer Name'}</p>
                                        <p className='detailsRightValue-drf'>{disbursalData?.cust_name}</p>
                                    </div>
                                    <div className='col-md-4'>
                                        <p className='detailsRightLabel'>{'Customer Account Number'}</p>
                                        <p className='detailsRightValue-drf'>{disbursalData?.account_no}</p>
                                    </div>
                                    <div className='col-md-4'>
                                        <p className='detailsRightLabel'>{'Customer Disbursal Amount'}</p>
                                        <p className='detailsRightValue-drf'> {disbursalData?.disbursal_amt}</p>
                                    </div>
                                </div>
                                :
                                <div className='text-center my-3'>
                                    No Data Found
                                </div>
                            }
                        </div>
                        : null
                    }
                    {
                        isBtCase ?
                            transactionData.filter(value => value?.api_status != 2).every(checkIsFailed) && (transactionData.filter(value => value?.api_status != 2).length < drfDataArray.length) &&
                            checkHasPermission('add-payto-bank-customer') &&
                            <div className='d-flex justify-content-end mt-2'>
                                <button className='btn btn-custom' onClick={togglePayToCustomerModal}>
                                    {`Pay to ${paytype}`}
                                </button>
                            </div>
                            :

                            (transactionData.filter(value => value?.api_status != 2)).every(checkIsFailed) && ((transactionData.filter(value => value?.api_status != 2)).length < 1) &&
                            checkHasPermission('add-payto-bank-customer') &&
                            <div className='d-flex justify-content-end mt-2'>
                                <button className='btn btn-custom' onClick={togglePayToCustomerModal}>
                                    {`Pay to ${paytype}`}
                                </button>
                            </div>
                    }
                    {
                        ((transactionData.filter(value => value?.api_status != 2)) || []).map((trans) => {
                            return (
                                <div className='mt-3'>
                                    <div style={{ borderRadius: "5px", width: "100%", border: "1px solid #CBCBCB" }}>
                                        <div className='border p-2' style={{ backgroundColor: "#F8F8F8", borderRadius: "5px 5px 0 0 " }}>
                                            <h5>Transaction Detail</h5>
                                            <h5 style={{ float: "right", display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: "-24px" }}>API Status:
                                                <span style={{ marginLeft: '5px', fontSize: '14px', fontWeight: '600', color: (trans?.api_status ? 'green' : 'red') }}>
                                                    {trans?.api_status ? ' SUCCESS' : ' FAILED'}
                                                </span>
                                                {!trans?.api_status ?
                                                    <span className="ml-2" data-for='retry-pay' data-tip style={{ "cursor": "pointer" }} onClick={() => handleRetryPayment(trans)}>
                                                        <i className={`fa fa-retweet fa-lg text-success`} aria-hidden="true"></i>
                                                    </span>
                                                    : null
                                                }
                                                <ReactTooltip id='retry-pay'>{`Retry Pay to ${paytype}`}</ReactTooltip>
                                            </h5>
                                        </div>
                                        <div className='row p-2'>
                                            <div className='col-md-3'>
                                                <p className='detailsRightLabel'>{'Customer Name'}</p>
                                                <p className='detailsRightValue-drf'>{trans?.cust_name}</p>
                                            </div>
                                            <div className='col-md-3'>
                                                <p className='detailsRightLabel'>{'Customer Account Number'}</p>
                                                <p className='detailsRightValue-drf'>{trans?.account_no}</p>
                                            </div>
                                            <div className='col-md-3'>
                                                <p className='detailsRightLabel'>{'Customer Account Type'}</p>
                                                <p className='detailsRightValue-drf'>{trans?.account_type}</p>
                                            </div>
                                            <div className='col-md-3'>
                                                <p className='detailsRightLabel'>{'Customer Bank IFSC'}</p>
                                                <p className='detailsRightValue-drf'>{trans?.ifsc}</p>
                                            </div>
                                            <div className='col-md-3 mt-3'>
                                                <p className='detailsRightLabel'>{'Customer Disbursal Amount'}</p>
                                                <p className='detailsRightValue-drf'>{trans?.disbursal_amt}</p>
                                            </div>
                                            <div className='col-md-3 mt-3'>
                                                <p className='detailsRightLabel'>{'KVB UTR No.'}</p>
                                                <p className='detailsRightValue-drf'>{trans?.utr_no}</p>
                                            </div>
                                            <div className='col-md-3 mt-3'>
                                                <p className='detailsRightLabel'>{'KVB LAN No.'}</p>
                                                <p className='detailsRightValue-drf'>{trans?.lan_no}</p>
                                            </div>
                                            <div className='col-md-3 mt-3'>
                                                <p className='detailsRightLabel'>{'Remarks'}</p>
                                                <p className='detailsRightValue-drf'>{trans?.api_status_reason}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    {
                        showModal &&
                        <PayToCustomerModal
                            state={showModal}
                            toggleModal={togglePayToCustomerModal}
                            modalData={disbursalData}
                            leadId={leadId}
                            reloadData={fetchPayToCustomerDetails}
                            paytype={paytype}
                            drfData={drfData}
                            retryData={retryData}
                            transactionData={transactionData}
                        />
                    }
                </>
            }


        </>
    )
}

export default PayToCustomer